<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-layout px-2 wrap justify-center v-if="loadData">
      <v-flex px-2 xs12 sm12 md12 lg10 xl8 text-left>
        <v-layout py-4 wrap>
          <v-flex xs6 text-left>
            <span
              style="font-family:opensansbold;font-size:20px;color:#000000;"
              class="text-capitalize"
            >Your Order</span>
          </v-flex>
        </v-layout>
        <v-layout wrap pb-4>
          <v-flex>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs6 text-left>
            <span
              style="font-family:opensansbold;font-size:18px;color:#000000;"
              class="text-capitalize"
            >Order #1</span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start>
          <v-flex xs12 sm12 md12 lg9 xl9>
            <v-layout wrap>
              <v-flex v-for="(item,i) in orders.product" :key="i" xs6 sm4 md3 lg3 xl3 pa-4>
                <v-layout wrap>
                  <v-flex px-4 xs12>
                    <v-img :src="baseURL+'/u/'+item.photos[0]" height="100px" contain></v-img>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap>
                      <v-flex xs12 text-center style="height:50px">
                        <router-link :to="'/'+item._id+'/'+item.productname">
                          <span
                            style="font-family:opensanssemibold;font-size:14px;color:#000000;"
                          >{{item.productname.slice(0,30)+'...'}}</span>
                        </router-link>
                      </v-flex>
                      <v-flex xs12 text-center>
                        <span
                          style="font-family:opensanssemibold;font-size:14px;color:#2D2D2D;"
                        >₹ {{item.price}}</span>
                      </v-flex>
                      <v-flex xs12 text-center>
                        <span
                          style="font-family:opensanssemibold;font-size:14px;color:#000000;"
                        >Qty: {{orders.prdquantity[i]}}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md12 lg3 xl3>
            <v-card tile flat>
              <v-layout wrap>
                <v-flex xs12>
                  <span style="font-family:opensansbold;font-size:18px;color:#2D2D2D;">Order Summary</span>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs8 text-left>
                      <span
                        style="font-family:opensansregular;font-size:14px;color:#000000;"
                      >{{orders.product.length}} Item(s)</span>
                    </v-flex>
                    <v-flex xs4 text-left>
                      <span style="font-family:opensansbold;font-size:14px;color:#000000;">Total</span>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs8 text-left>
                      <span
                        style="font-family:opensansregular;font-size:14px;color:#000000;"
                      >{{formatDate(orders.init_date)}}</span>
                    </v-flex>
                    <v-flex xs4 text-left>
                      <span
                        style="font-family:opensansbold;font-size:14px;color:#000000;"
                      >{{orders.amount}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex py-2>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 text-left>
                      <span
                        style="font-family:opensansbold;font-size:15px;color:#000000;"
                      >Delivered to</span>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <span style="font-family:opensansregular;font-size:13px;color:#000000;">
                        {{orders.deliveryaddress.fullname}},
                        <br />
                        {{orders.deliveryaddress.streetAddress}}, {{orders.deliveryaddress.city}} , {{orders.deliveryaddress.pincode}}
                      </span>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex py-2>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 text-left>
                      <span
                        style="font-family:opensansbold;font-size:15px;color:#000000;"
                      >Estimated Time {{30}} Min</span>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <span
                        style="font-family:opensansregular;font-size:14px;color:#00AB3F;"
                      >Out for Delivery</span>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <span
                        style="font-family:opensanssemibold;font-size:14px;color:#AEAEAE;"
                      >Arriving in {{10}} Min</span>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex py-2>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["id"],
  data() {
    return {
      menu: false,
      appLoading: false,
      orders: {},
      loadData: false,
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/purchase/get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.$route.params.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.orders = response.data.data;
          this.loadData = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },

    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>